var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCheckedRoundedCheckbox = function SvgCheckedRoundedCheckbox(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37049 5.37049 0 12 0C18.6295 0 24 5.37049 24 12C24 18.6295 18.6295 24 12 24C5.37049 24 0 18.6295 0 12ZM6.17676 11.8228L11.0554 16.6819L18.7079 9.04906L17.3112 7.65234L11.0554 13.9081L7.57348 10.4261L6.17676 11.8228Z",
    fill: "#0179FF"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedRoundedCheckbox);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEyQzAgNS4zNzA0OSA1LjM3MDQ5IDAgMTIgMEMxOC42Mjk1IDAgMjQgNS4zNzA0OSAyNCAxMkMyNCAxOC42Mjk1IDE4LjYyOTUgMjQgMTIgMjRDNS4zNzA0OSAyNCAwIDE4LjYyOTUgMCAxMlpNNi4xNzY3NiAxMS44MjI4TDExLjA1NTQgMTYuNjgxOUwxOC43MDc5IDkuMDQ5MDZMMTcuMzExMiA3LjY1MjM0TDExLjA1NTQgMTMuOTA4MUw3LjU3MzQ4IDEwLjQyNjFMNi4xNzY3NiAxMS44MjI4WiIgZmlsbD0iIzAxNzlGRiIvPgo8L3N2Zz4K";